import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { DATASET } from '@utils/constants';
import {
  useFrustrationSignalQueryManager,
  useFrustrationSignalQueryStatus,
} from '../../queryManager';

/**
 * Create a query configuration for frustration signal data
 */
export const createFrustrationSignalQuery = (
  metricList: string[] = [],
  interval,
  granularity = 'ALL',
  filter = [] as any[][],
  options = {},
) => {
  const query = {
    type: 'timeseries',
    dataset: DATASET,
    granularity: granularity,
    options: {
      withTotals: true,
      ...(options || {}),
    },
    interval,
    filter,
    metrics: metricList,
    context: window.conviva.context,
  };

  return {
    queries: [query],
  };
};

/**
 * Hook for querying frustration signal data with concurrency management
 */
function useFrustrationSignalQuery({ signalId, queryKey, queryFn, options }) {
  const queryManager = useFrustrationSignalQueryManager(signalId);
  const { queued } = useFrustrationSignalQueryStatus(signalId);

  const queryRes = useQuery(queryKey, () => queryManager.exec(queryFn), {
    ...options,
  });

  const res = useMemo(
    () => ({
      ...queryRes,
      queued,
    }),
    [queryRes, queued],
  );

  // cancel any queued query on unmount
  useEffect(() => {
    return () => {
      queryManager.abort();
    };
  }, []);

  return res;
}

export default useFrustrationSignalQuery;
